<template>
  <div class="main-hero" style="background-color: #FE828C">
    <b-container>
      <b-row class="flex-column-reverse flex-md-row">
        <b-col
          lg="7"
          md="7"
          class="coming-soon__text"
          style="padding-bottom: 10px;"
        >
          <span class="single">Derriana's Sweet 16 🎉</span>
          <hr />
          <h3 style="color:black">
            Thank you, everyone, for being a part of the unforgettable journey that was Derriana's Sweet 16!
          </h3>
          <h5>
            Your presence turned this special occasion into an extraordinary celebration, and we're grateful for the warmth and joy you brought.
          </h5>
          <h5>
            The evening was filled with vibrant energy, laughter, and magical moments as we commemorated Derriana's transition into this exciting chapter of her life.
            Your enthusiasm and participation on the dance floor created an electric atmosphere, and Derriana was overjoyed to share these moments with such wonderful company.
          </h5>
          <h5>
            Thank you for contributing to the magic of Derriana's Sweet 16! Your love and support have left a lasting imprint on this milestone celebration. Here's to the cherished memories and the incredible journey ahead!
          </h5>

          <div class="input-rsvp" v-if="false">
            <div style="padding: 20px">
              <h5 style="margin-bottom: 10px;">
                <strong>
                  Reserve your spot, s'il vous plait!
                </strong>
              </h5>
              <b-form-group>
                <label-info
                    id="form-name"
                    label-name="Your Name"
                    label-info=""
                />
                <b-form-input
                  v-model="formRSVP.name"
                  type="text"
                  class="form-control"
                  placeholder="Derriana Smith"
              />
              </b-form-group>
              <b-form-group>
                <label-info
                    id="form-email"
                    label-name="Your Email"
                    label-info=""
                />
                <b-form-input
                    type="email"
                    v-model="formRSVP.email"
                    class="form-control"
                    placeholder="Enter Email to RSVP"
                />
              </b-form-group>
              <span class="error">
                <div v-for="(anError, i) in this.errors" :key="`err_${i}`">
                    {{ anError }}
                </div>
              </span>
              <b-form-group>
                <button
                    class="btn btn-success float-right"
                    style="border: none; background-color: #fe818b"
                    @click="submitRSVP"
                >
                  RSVP
                </button>
              </b-form-group>
            </div>
          </div>
          <social-media />
        </b-col>
        <b-col lg="5" md="5" class="banner-img">
          <b-img
              thumbnail fluid src="/assets/_birthday/image7.jpeg"
              alt="Derriana's Image"/>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import SocialMedia from "@/components/home/SocialMedia";
import LabelInfo from "@/components/common/labelInfo";

export default {
  name: "Home_Main_Row",
  created(){
    this.formReset();
  },
  mounted() {},
  components: {
    SocialMedia,
    LabelInfo
  },
  methods: {
    submitRSVP() {

      if (this.simpleValidate().length > 0) return;
      
      this.$emit("applied", this.formRSVP);
      this.formReset();
    },
    simpleValidate(){
      this.errors = [];

      if (this.formRSVP && !this.validateEmail(this.formRSVP.email))
        this.errors.push("Please enter a valid email");

      if (this.formRSVP && !this.formRSVP.name || this.formRSVP.name.length === 0)
        this.errors.push("Please enter your name");

      return this.errors;
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    formReset(){
      this.formRSVP = null;
      this.formRSVP = this.formDefault;
    }
  },
  data() {
    return {
      formRSVP: null,
      formDefault:{
        name: null,
        email: null
      },
      errors: []
    };
  },
};
</script>

<style lang="scss" scoped>
.single {
  max-width: 600px;
  width: 100%;
  // height: 134px;

  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 56px;
  line-height: 120%;
  /* or 67px */

  /* Body */

  color: #222222;
}
.coming-soon__text {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.main-hero {
  //background: url("../../assets/img/home/hero.svg") no-repeat center center;
  //background-size: cover;
  background-color: #FE828C;
  h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    line-height: 55px;
    color: #0d0d21;
    display: flex;
    column-gap: 15px;
    margin-bottom: 16px;
    span {
      font-style: normal;
      font-weight: bold;
      font-size: 20px;
      line-height: 27px;
      display: flex;
      align-items: center;
      color: #ffcc4d;
      margin-top: -5px;
    }
  }
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #f3f6f9;
    margin-bottom: 30px;
  }
  .input-rsvp {
    margin-top: 25px;
    display: flex;
    justify-content: center;
    column-gap: 8px;
    min-height: 50px;
    background-color: #b2ac88;
    border-radius: 15px;
    margin-bottom: 15px;
    & > div {
      width: 100%;
    }
    .error {
      display: inline-block;
      margin-bottom: 6px;
      font-size: 12px;
      margin-left: 10px;
      color: #fff;
    }
    .form-control {
      padding: 12px 27px;
      height: 40px;
      border-radius: 20px;
      border: 1px solid #fff;
      margin: 15px;
      &:focus {
        outline: none;
        border: 1px solid #fff;
      }
      &::-webkit-input-placeholder {
        /* Edge */
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
      }

      &:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
      }

      ::placeholder {
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
      }
    }
    .btn-success {
      background: #010610;
      border-radius: 32px;
      height: 40px;
      font-style: normal;
      font-weight: bold;
      font-size: 12px;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      padding: 12px 16px;
      min-width: 150px;
      &:after,
      &:before {
        content: none;
      }
    }
  }
  img {
    margin: 40px 0;
  }
}
@media (min-width: 992px) {
  .banner-img {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 25px;
  }
}
@media (max-width: 768px) {
  .coming-soon__text {
    margin-top: 24px;
  }
  .main-hero {
    padding: 44px 0;
    h3 {
      font-size: 24px;
    }
    .input-rsvp {
      display: grid;
      grid-template-columns: 1fr;
      justify-items: start;
      margin-bottom: 12px;
    }
    .single {
      display: contents;
      height: unset;
    }
  }
  .banner-img svg {
    height: 400px;
  }
}
@media (max-width: 640px) {
  .single {
    font-size: 32px;
  }
}
</style>
